import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';

export default function AdminAuthLayout({ title, children }) {
    return (
        <Box className="admin-auth-page">
            <Card className="admin-auth-card">
                <CardContent className="admin-auth-card-content">
                    <Box className="admin-auth-logo-container">
                        <img src="/neofeedAI.png" alt="NeoFeed AI" className="admin-auth-logo" />
                    </Box>

                    <Typography variant="h5" className="admin-auth-title">
                        {title}
                    </Typography>

                    {children}
                </CardContent>
            </Card>
        </Box>
    );
}
